import { motion } from "framer-motion";

const STORY_IMG_1 =
  "https://images.unsplash.com/photo-1642522282478-516bcd2c1917?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwyfHxoaWdoJTIwZmFzaGlvbiUyMG1vZGVsJTIwZGFya3xlbnwwfHx8fDE3ODExMDk0NTl8MA&ixlib=rb-4.1.0&q=85";
const STORY_IMG_2 =
  "https://images.unsplash.com/photo-1697924293303-34488b60bf36?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwxfHxoaWdoJTIwZmFzaGlvbiUyMG1vZGVsJTIwZGFya3xlbnwwfHx8fDE3ODExMDk0NTl8MA&ixlib=rb-4.1.0&q=85";

export default function BrandStory() {
  return (
    <section
      id="story"
      data-testid="brand-story"
      className="relative bg-midnight-deep py-24 md:py-36 px-6 md:px-12 lg:px-24 overflow-hidden"
    >
      {/* Background type */}
      <div
        aria-hidden
        className="absolute -top-10 left-0 right-0 text-center pointer-events-none select-none"
      >
        <span className="mega-text text-[16vw] text-white/[0.025]">
          ASYMMETRY
        </span>
      </div>

      <div className="relative grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-16 items-center">
        {/* Overlapping image stack */}
        <div className="md:col-span-6 relative">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
            className="relative aspect-[4/5] w-[80%] denim-glow"
          >
            <img
              src={STORY_IMG_1}
              alt="Brand story atmospheric"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-tr from-denim/20 via-transparent to-transparent" />
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 1, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
            className="hidden md:block absolute -right-4 bottom-[-40px] w-[55%] aspect-[3/4] border border-silver/30 silver-glow"
          >
            <img
              src={STORY_IMG_2}
              alt="Editorial silhouette"
              className="w-full h-full object-cover"
            />
          </motion.div>
          {/* Edition tag */}
          <div className="absolute -left-2 top-6 vertical-text text-[10px] tracking-[0.5em] uppercase text-silver/60">
            House of Asymmetry — Est. 2026
          </div>
        </div>

        {/* Text */}
        <div className="md:col-span-6 md:pl-8">
          <div className="eyebrow mb-6">The House</div>
          <motion.h2
            initial={{ opacity: 0, y: 28 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
            className="font-serif text-white text-4xl sm:text-5xl md:text-6xl leading-[0.95] tracking-tight"
          >
            A house of <span className="italic text-silver">artistic</span>
            <br />
            luxury.
          </motion.h2>
          <div className="mt-8 space-y-6 text-white/70 text-base md:text-lg font-light leading-relaxed max-w-xl">
            <p data-testid="story-paragraph-1">
              Asymmetry Edits was founded on a single conviction — that
              luxury must be felt, not announced. We dissolve the line
              between couture and street, between artefact and apparel.
            </p>
            <p data-testid="story-paragraph-2">
              Every collection is a slow conversation between hand,
              material, and silhouette. DenimGlow is our opening
              statement — seven objects that refuse symmetry, embrace
              shimmer, and remain unforgettable.
            </p>
          </div>

          {/* Signature */}
          <div className="mt-12 flex items-center gap-6">
            <div className="h-px w-16 bg-silver/60" />
            <div>
              <div className="font-serif italic text-white text-2xl">
                House of Asymmetry Edits
              </div>
              <div className="text-[10px] tracking-[0.4em] uppercase text-silver/70 mt-1">
                Maison · Milano
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
